import type { MobileBlockReparentingApi } from './api';
import type { PublicSlotKey } from '#packages/apilib';

export const MobileBlockReparantingApiKey: PublicSlotKey<MobileBlockReparentingApi> =
  {
    name: 'MobileBlockReparantingApi',
    public: true,
  };
